import styled from "styled-components";
import ClickableElement, { ClickableLink } from "../../utils/ClickableElement";

const WideButton = styled(ClickableElement)`
  display: flex;
  justify-content: space-around;
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const NarrowButton = styled(ClickableElement)`
  display: flex;
  justify-content: space-around;
  width: 33%;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const WideBlueButton = styled(WideButton)(
  ({ theme }) => `
  background: ${theme.colors.buttonBlue};
  color: ${theme.colors.white};
  &:hover {
    background: ${theme.colors.buttonDarkBlue};
  }
`
);

export const WideDarkGreyButton = styled(WideButton)(
  ({ theme }) => `
  background: ${theme.colors.darkgrey};
  color: ${theme.colors.white};
`
);

export const NarrowDarkGreyButton = styled(NarrowButton)(
  ({ theme }) => `
  background: ${theme.colors.darkgrey};
  color: ${theme.colors.white};
`
);

export const WideLightGreyButton = styled(WideButton)(
  ({ theme }) => `
  background: ${theme.colors.highlightLightGrey};
  color: ${theme.colors.black};
`
);

export const NarrowLightGreyButton = styled(NarrowButton)(
  ({ theme }) => `
  background: ${theme.colors.highlightLightGrey};
  color: ${theme.colors.black};
`
);

export const CancelButton = styled(WideButton)(
  ({ theme }) => `
  background: ${theme.colors.darkgrey};
  color: ${theme.colors.white};
  width: 33%;
  margin-right: 1rem;
`
);

export const DeleteCourseButton = styled(WideButton)(
  ({ theme }) => `
  background: ${theme.colors.darkred};
  color: ${theme.colors.white};
  width: 33%;
  margin-right: 1rem;
`
);

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const WideButtonLink = styled(ClickableLink)`
  width: 100%;

  button {
    display: flex;
    justify-content: space-around;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;

export const WideBlueButtonLink = styled(WideButtonLink)(
  ({ theme }) => `
  background: ${theme.colors.buttonBlue};
  color: ${theme.colors.white};
`
);

export const WideDarkGreyButtonLink = styled(WideButtonLink)(
  ({ theme }) => `
  background: ${theme.colors.darkgrey};
  color: ${theme.colors.white};
`
);

export const WideLightGreyButtonLink = styled(WideButtonLink)(
  ({ theme }) => `
  background: ${theme.colors.highlightLightGrey};
  color: ${theme.colors.black};
`
);
